import { ADSyncerSpecifics, ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { BaseNetworkActionValidator } from '../base.network.action.validator';

export class RemoveADIntegrationValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = false;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    return (record.specifics as ADSyncerSpecifics).isAdIntegration === true;
  }
}
